import moment from 'moment';
import { split } from 'ramda';

import {
  timeFormat,
  dateFormat,
  dateFormatCompare,
  timeFormatCompare,
} from 'utils/moment/moment.constant';

import { COURSE_TIME_RANGE } from 'utils/helpers/helper.constant';
import { getArrayIds, objectsAreSameByKeys, filterObject } from 'utils/helpers/helper.general';

import {
  compareTimeRangeAndSetDefault,
  compareDateRangeAndSetDefault,
} from 'utils/moment/moment.utils';
import { ConsoleSqlOutlined } from '@ant-design/icons';

const setFormValues = (form, initForm, values) => {
  // update data in the general form
  if (
    Array.isArray(initForm) &&
    initForm?.length > 0 &&
    values &&
    Object.keys(values).length != 0
  ) {
    // form fields path
    const initFields = initForm[0]?.children;
    if (initFields?.length > 0) {
      for (let i = 0; i < initFields?.length; i++) {
        const currentItem = initFields[i];
        const formName = currentItem?.name;
        // Sub object !
        if (formName.indexOf('.') != -1) {
          // Split by .
          const groupPath = split('.', formName);
          // Only level 2 at the moment
          if (groupPath.length == 2) {
            const group = groupPath[0];
            const name = groupPath[1];
            if (
              values[group] &&
              values[group].hasOwnProperty(name) &&
              values[group][name]
            ) {
              form.setFieldsValue({
                [formName]: values[group][name],
              });
            }
          }
        } else {
          // only for time
          if (formName && formName.indexOf('_time') >= 0) {
            // for time-range fields
            form.setFieldsValue({
              [formName]: values[formName] ? moment(values[formName]) : '',
            });
          } else if (formName && formName.indexOf('Date') >= 0) {
            form.setFieldsValue({
              [formName]: values[formName] ? moment(values[formName]) : null,
            });
          } else if (formName && formName.indexOf('editor') >= 0) {
            if (
              !!currentItem?.hiddenChain &&
              !!values?.[(currentItem?.hiddenChain)]
            ) {
              const parentValue =
                values[(currentItem?.hiddenChain)];
              form.setFieldsValue({
                [formName]: parentValue || '',
              });
            } else {
              form.setFieldsValue({
                [formName]: values[formName] || '',
              });
            }
          } else if (formName == 'level') {
            // for time-range fields
            form.setFieldsValue({
              [formName]: values[formName] ? values[formName] : 0,
            });
          } else if (formName == 'password') {
            // for time-range fields
            form.setFieldsValue({
              [formName]: values[formName] ? values[formName] : '',
            });
          } else if (formName && formName.indexOf('audience-select') >= 0) {
            const audienceO = values?.audience;

            let resArr = [];
            const classes =
              (!!audienceO?.classes && getArrayIds(audienceO?.classes)) || [];
            const courses =
              (!!audienceO?.courses && getArrayIds(audienceO?.courses)) || [];
            const students =
              (!!audienceO?.students && getArrayIds(audienceO?.students)) || [];
            const users =
              (!!audienceO?.users && getArrayIds(audienceO?.users)) || [];
            const audiences =
              (!!audienceO?.audiences && getArrayIds(audienceO?.audiences)) || [];
            const school =
              (!!audienceO?.school && audienceO?.school.length > 0) ? [audienceO?.school] : [];
            resArr = classes && classes?.length > 0 ? resArr.concat(classes) : resArr;
            resArr = courses && courses?.length > 0 ? resArr.concat(courses) : resArr;
            resArr = students && students?.length > 0 ? resArr.concat(students) : resArr;
            resArr = users && users?.length > 0 ? resArr.concat(users) : resArr;
            resArr = audiences && audiences?.length > 0 ? resArr.concat(audiences) : resArr;
            resArr = school && school?.length > 0 ? resArr.concat(school) : resArr;
            // for time-range fields
            form.setFieldsValue({
              ['audience-select']: resArr || [],
            });
          } else {
            form.setFieldsValue({
              [formName]: values[formName] ? values[formName] : '',
            });
          }
        }
      }
    }
  }
};

const prepearFormValue = (initForm, values) => {
  // form fields path
  let prepearedValues = {};
  if (
    Array.isArray(initForm) &&
    initForm?.length > 0 &&
    values &&
    Object.keys(values).length != 0
  ) {
    const initFields = initForm[0]?.children;

    for (let param in values) {
      for (let i = 0; i < initFields?.length; i++) {
        if (initFields[i]?.name === param) {
          // Sub object with path!
          if (initFields[i].name.indexOf('.') != -1) {
            // Split by .
            const groupPath = split('.', initFields[i].name);
            // Only level 2 at the moment
            if (groupPath.length == 2) {
              const group = groupPath[0];
              const name = groupPath[1];
              prepearedValues[group] = {
                ...prepearedValues[group],
                [name]: values[param],
              };
            }
            // simple
          } else {
            prepearedValues[param] = values[param];
          }
        }
      }
    }
  }

  return prepearedValues;
};

const prepearFormValueRemoveHiddenChain = (initForm, values) => {
  // form fields path
  let prepearedValues = {};
  if (
    Array.isArray(initForm) &&
    initForm?.length > 0 &&
    values &&
    Object.keys(values).length != 0
  ) {
    const initFields = initForm[0]?.children;
    prepearedValues = { ...values };
    for (let param in values) {
      for (let i = 0; i < initFields?.length; i++) {
        const currentItem = initFields[i];
        if (currentItem?.name === param && currentItem?.hiddenChain) {
          delete prepearedValues[(currentItem?.name)];
        }
      }
    }
  }

  return prepearedValues;
};

const convertObjToFormValues = (initForm, values) => {
  // update data in the general form
  if (
    Array.isArray(initForm) &&
    initForm?.length > 0 &&
    values &&
    Object.keys(values).length != 0
  ) {
    // form fields path
    const initFields = initForm[0]?.children;
    let objFromValues = {};

    for (let i = 0; i < initFields?.length; i++) {
      const formName = initFields[i].name;
      // Sub object !
      if (formName.indexOf('.') != -1) {
        // Split by .
        const groupPath = split('.', formName);
        // Only level 2 at the moment
        if (groupPath.length == 2) {
          const group = groupPath[0];
          const name = groupPath[1];
          if (
            values[group] &&
            values[group].hasOwnProperty(name) &&
            values[group][name]
          ) {
            Object.assign(objFromValues, {
              [formName]: values[group][name],
            });
          }
        }
      } else {
        // only for time
        if (formName && formName.indexOf('_time') > 0) {
          // for time-range fields
          Object.assign(objFromValues, {
            [formName]: values[formName] ? moment(values[formName]) : '',
          });
        } else if (formName && formName.indexOf('Date') >= 0) {
          Object.assign(objFromValues, {
            [formName]: values[formName] ? moment(values[formName]) : null,
          });
        } else if (formName && formName.indexOf('editor') >= 0) {
          const nameArr = formName.split('-');
          const parentValue = values[nameArr[0]];
          Object.assign(objFromValues, {
            [formName]: parentValue || '',
          });
        } else if (formName == 'level') {
          // for time-range fields
          Object.assign(objFromValues, {
            [formName]: values[formName] ? values[formName] : 0,
          });
        } else if (formName == 'password') {
          // for time-range fields
          Object.assign(objFromValues, {
            [formName]: values[formName] ? values[formName] : '',
          });
        } else {
          Object.assign(objFromValues, {
            [formName]: values[formName] ? values[formName] : '',
          });
        }
      }
    }
    return objFromValues;
  } else {
    return null;
  }
};

const disabledDateFrom = current => {
  const now = moment();
  let dateDisabled = now;
  const compareDates = compareDateRangeAndSetDefault(current, dateDisabled);
  // Can not select days before today and today
  // current && current < moment().startOf('day')
  return compareDates?.isAfter || compareDates?.isSam;
};

// for onlu for 2 step
const getObjectByPrevKeys = (currentObject, prevObject) => {
  if (
    currentObject &&
    prevObject &&
    Object.keys(currentObject).length != 0 &&
    Object.keys(prevObject).length != 0
  ) {
    let newObj = {};
    for (let param in currentObject) {
      if (prevObject.hasOwnProperty(param)) {
        if (
          typeof prevObject[param] === 'object' &&
          !Array.isArray(prevObject[param]) &&
          prevObject[param] !== null
        ) {
          const prevKeysArr = Object.keys(prevObject[param]);
          const newParamObj = {};
          prevKeysArr?.map(key => {
            if (currentObject[param].hasOwnProperty(key)) {
              Object.assign(newParamObj, { [key]: currentObject[param][key] });
            }
          });
          Object.keys(newParamObj).length != 0 &&
            Object.assign(newObj, { [param]: newParamObj });
        } else {
          Object.assign(newObj, { [param]: currentObject[param] });
        }
      }
    }
    return newObj;
  } else {
    return null;
  }
};

// convert dates and time to the string
const prepeareForCompare = objectWithValues => {
  if (objectWithValues && Object.keys(objectWithValues).length != 0) {
    const newObj = {};
    for (let key in objectWithValues) {
      if (key && key.indexOf('_time') > 0) {
        Object.assign(newObj, {
          [key]: moment(objectWithValues[key], dateFormatCompare).format(
            `${dateFormatCompare} ${timeFormat}`,
          ),
        });
      } else if (key && key.indexOf('Date') > 0) {
        Object.assign(newObj, {
          [key]: moment(objectWithValues[key]).format(
            `${dateFormatCompare}`,
          ),
        });
      } else {
        Object.assign(newObj, {
          [key]: objectWithValues[key],
        });
      }
    }
    return newObj;
  } else {
    return null;
  }
};

const isEqualFormValues = (initForm, currentElement, formValues) => {
  if (
    Array.isArray(initForm) &&
    initForm?.length > 0 &&
    currentElement &&
    Object.keys(currentElement).length != 0 &&
    formValues &&
    Object.keys(formValues).length != 0
  ) {
/*     const elementToFormValues = convertObjToFormValues(
      initForm,
      currentElement,
    );
    const prepearedValues = prepeareForCompare(formValues);
    const prepearedElementValues = prepeareForCompare(elementToFormValues); */
    const sendingFormData = prepearFormValue(initForm, formValues);
    const sendingFormClear = prepearFormValueRemoveHiddenChain(
      initForm,
      sendingFormData,
    );
    const formValsKeys = Object.keys(sendingFormClear);
    const compareElement = filterObject(currentElement, formValsKeys);

    const isEqualValues = objectsAreSameByKeys(
      sendingFormClear,
      compareElement,
      formValsKeys,
    );
    
    return isEqualValues;
  } else {
    return false;
  }
};

const checkCoursesTimeSetDefaultRange = (startTime, endTime) => {
  if (startTime && endTime) {
    const newStartDate = startTime.clone();
    const newRange = compareTimeRangeAndSetDefault(newStartDate, endTime);
    if (
      newRange?.isSame ||
      newRange?.isBefore ||
      (newRange?.isAfter && newRange?.diff >= COURSE_TIME_RANGE)
    ) {
      const newEndDate = newStartDate.add(COURSE_TIME_RANGE, 'minutes');
      return {
        time_start: startTime,
        time_end: newEndDate,
      };
    } else if (newRange?.isAfter && newRange?.diff == COURSE_TIME_RANGE) {
      return null;
    }
  } else {
    return null;
  }
};

const checkTimeSetDefaultRange = (startTime, endTime) => {
  if (startTime && endTime) {
    const newStartDate = moment(startTime).clone();
    const newRange = compareTimeRangeAndSetDefault(newStartDate, endTime);
    if (newRange?.isSame || newRange?.isBefore) {
      const newEndDate = newStartDate.add(COURSE_TIME_RANGE, 'minutes');
      return {
        time_start: startTime,
        time_end: newEndDate,
      };
    } else if (
      newRange?.isAfter &&
      (newRange?.diff == COURSE_TIME_RANGE ||
        newRange?.diff >= COURSE_TIME_RANGE)
    ) {
      return null;
    }
  } else {
    return null;
  }
};

const checkDateSetDefaultRange = (startTime, endTime) => {
  if (startTime && endTime) {
    const newStartDate = startTime.clone();
    const newRange = compareDateRangeAndSetDefault(newStartDate, endTime);

    if (newRange?.isBefore) {
      return {
        date_start: startTime,
        date_end: newStartDate,
      };
    } else if (
      newRange?.isAfter &&
      (newRange?.diff == 1 || newRange?.diff >= 1)
    ) {
      return null;
    } else if (newRange?.isSame) {
      return null;
    }
  } else {
    return null;
  }
};

const setTimeRangeAfterChanges = (form, allFields) => {
  if (form && allFields && Object.keys(allFields).length > 0) {
    if (
      allFields?.duration == 'more' &&
      allFields?.time_from &&
      allFields?.time_to
    ) {
      const startTime = allFields?.time_from,
        endTime = allFields?.time_to,
        newTimeValues = checkTimeSetDefaultRange(startTime, endTime);
      if (newTimeValues && newTimeValues?.time_end) {
        form.setFieldsValue({
          time_from: newTimeValues?.time_start,
          time_to: newTimeValues?.time_end,
        });
      }
    }
  }
};

const setDateRangeAfterChanges = (form, allFields) => {
  if (allFields && Object.keys(allFields).length > 0) {
    if (
      allFields?.duration == 'more' &&
      allFields?.date_from &&
      allFields?.date_to
    ) {
      const startDate = allFields?.date_from,
        endDate = allFields?.date_to,
        newDateValues = checkDateSetDefaultRange(startDate, endDate);
      if (newDateValues && newDateValues?.date_end) {
        form.setFieldsValue({
          date_from: newDateValues?.date_start,
          date_to: newDateValues?.date_end,
        });
      }
    }
  }
};

export {
  setFormValues,
  prepearFormValue,
  prepearFormValueRemoveHiddenChain,
  disabledDateFrom,
  getObjectByPrevKeys,
  prepeareForCompare,
  convertObjToFormValues,
  isEqualFormValues,
  checkTimeSetDefaultRange,
  checkDateSetDefaultRange,
  checkCoursesTimeSetDefaultRange,
  setTimeRangeAfterChanges,
  setDateRangeAfterChanges,
};
